import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { emailApi } from '../api/emailApi';
import { isEmailSyncEnabled, markEmailSyncUnavailable, shouldDisableEmailSync } from '../api/emailSync';

const THREAD_SYNC_INTERVAL_MS = 60_000;

/** Pull fresh Gmail state for the open thread — uses the frontdesk message UUID. */
export function useEmailThreadSync(messageId: string | null | undefined) {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!messageId || !isEmailSyncEnabled()) return;

    let cancelled = false;

    const syncThread = () => {
      if (!isEmailSyncEnabled()) return;

      void emailApi
        .syncThread(messageId)
        .then(() => {
          if (cancelled) return;
          void queryClient.invalidateQueries({ queryKey: keys.email.message(messageId) });
          void queryClient.invalidateQueries({ queryKey: keys.email.messages() });
        })
        .catch((err) => {
          if (shouldDisableEmailSync(err)) {
            markEmailSyncUnavailable();
          }
        });
    };

    syncThread();
    const intervalId = window.setInterval(syncThread, THREAD_SYNC_INTERVAL_MS);

    return () => {
      cancelled = true;
      window.clearInterval(intervalId);
    };
  }, [messageId, queryClient]);
}
